<template>
	<div class="company-settings">
		<el-row :gutter="20">
			<el-col :span="12">
				<h2 class="font-semi-bold">Company Settings</h2>
			</el-col>
			<el-col :span="12" class="text-right">
				<span class="mr-8">
					<el-button :disabled="isAdmin !== 'admin'" class="primary-settings-button__save" icon="el-icon-copy-document" @click="callCopyData">
						Apply to Locations
					</el-button>
				</span>
			</el-col>
		</el-row>
		<div class="my-2 activities-tab">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="Activities" name="activities">
					<!-- Activities -->
					<!-- Sections -->
					<all-company-sections />
					<!-- Coverage Activities -->
					<all-updated-coverage-activities></all-updated-coverage-activities>
					<!-- Non Coverage Activities -->
					<all-non-coverage-activities />
					<!-- Add or edit station modal  -->
					<add-or-edit-station :append-to-body="true"></add-or-edit-station>
				</el-tab-pane>
				<el-tab-pane label="Guidelines/Policy" name="guidelines">
					<Staff v-if="activeName == 'guidelines'" />
				</el-tab-pane>
			</el-tabs>
		</div>

		<el-dialog v-if="outlet" class="daily-activity-modal" width="100" :show-close="false" :fullscreen="true" :visible.sync="daily_activity_view">
			<activity-daily-view :store-id="outlet" :day-list="daysList" @closeActivityView="openDailyView"></activity-daily-view>
		</el-dialog>

		<grouped-coverage-activity-list></grouped-coverage-activity-list>
		<add-update-activity></add-update-activity>
		<combined-non-coverage-activity></combined-non-coverage-activity>
	</div>
</template>

<script>
import AllCompanySections from "./AllCompanySections.vue";
import AllNonCoverageActivities from "./AllNonCoverageActivities.vue";
import settingsMixin from "../../../../../../mixins/settingsMixin";
import ActivityDailyView from "../../storeSettings/activities/ActivityDailyView.vue";
import AllUpdatedCoverageActivities from "./AllUpdatedCoverageActivities.vue";
import GroupedCoverageActivityList from "./GroupedCoverageActivityList.vue";
import AddOrEditStation from "./AddOrEditStation.vue";
import Staff from "../../storeSettings/staff/Staff.vue";
import AddUpdateActivity from "./AddUpdateActivity.vue";
import CombinedNonCoverageActivity from "./CombinedNonCoverageActivity.vue";
export default {
	name: "CompanySettings",
	components: {
		AddOrEditStation,
		AllCompanySections,
		AllNonCoverageActivities,
		ActivityDailyView,
		AllUpdatedCoverageActivities,
		GroupedCoverageActivityList,
		Staff,
		AddUpdateActivity,
		CombinedNonCoverageActivity,
	},
	mixins: [settingsMixin],
	data() {
		return {
			activeName: "activities",
		};
	},
	computed: {
		localSections() {
			let result = [...this.sections];
			if(this.search_section) {
				result = result.filter((el) => el.name.toLowerCase().includes(this.search_section.toLowerCase()));
			}
			return result;
		}
	},
	watch: {
		async outlet(newValue, oldValue) {
			if (newValue) {
				await this.getStoreDepartmentsAndFunctions();
				await this.getSections();
				await this.getDailyActivities();
				await this.getNonCoverageActivities();
				await this.getGroupedCoverageActivityList();
				await this.getDesignation();
				await this.getDepartmentList();
				localStorage.setItem('store_id', newValue);

				// Store guidelines
				await this.getStaffDetails();
			}
		},
	},
	async mounted() {
		this.isAdmin = localStorage.getItem("user_access_level");
		await this.getHeadOfficeOutlets();
		await this.getAllOutlets();
		await this.getOrderTypes();

		await this.getAllStoreNonCoverageActivities();

		await this.getDepartmentList();
		await this.getAllCategory();
		await this.getAllSubCategories();
		const quantityArr = [];
		for(let i = 0; i <= 1000; i++) {
			quantityArr.push(i);
		}
		this.quantityList = [...quantityArr];
		if(localStorage.getItem('head_office_id')) {
			this.outlet = localStorage.getItem('head_office_id');
		}

		for (let i = 0; i < 401; i++) {
			let obj = {
				label: i,
				value: i
			}

			this.transaction_threshold_range.push(obj);
		}
	},
	async created() {
		await this.getAllSections();
	},
	methods: {
		handleClick(tab, event) {
			// console.log(tab, event);
		},
		callCopyData() {
			let command = 'activities';
			if(this.activeName == 'guidelines') {
				command = 'guidelines';
			}
			this.$confirm(`Do you really want to copy all ${command} to all stores?`, 'Warning!', {
				confirmButtonText: 'OK',
				dangerouslyUseHTMLString: true
			}).then(() => {
				this.copyCompanySettings(command);
			}).catch(err => {});
		}
	},
};
</script>

<style lang="scss">
.company-settings {
	font-family: inherit !important;
	.el-table th.el-table__cell > .cell {
		text-align: left !important;
	}
	.capitalize {
		text-transform: capitalize !important;
	}
	.el-table td.el-table__cell div {
		text-transform: capitalize !important;
	}
	.rounded {
		border-radius: 25px;
	}
	table.el-table.custom-non-cov-tbl  {
		position: relative;
		border-collapse: collapse;
		th {
			position: sticky;
			top: 0;
		}
	}
	.primary-settings-button {
		color: #F9A168 !important;
		border-color: #F9A168 !important;
		background: #FFFFFF !important;
		border-radius: 12px !important;
		min-width: 100px !important;
	}
	.primary-settings-button:hover {
		color: #FFFFFF !important;
		border-color: #F9A168 !important;
		background: #F9A168 !important;
	}
	.primary-settings-button__save {
		color: #FFFFFF !important;
		border-color: #F9A168 !important;
		background: #F9A168 !important;
		border-radius: 12px !important;
		min-width: 100px !important;
	}
	.primary-settings-button__save:hover {
		color: #F9A168 !important;
		border-color: #F9A168 !important;
		background: #FFFFFF !important;
	}
	.primary-settings-button__save:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}
	.popup-title {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 33px;
        text-transform: capitalize;
        color: #000000;
    }
	.daily-activity-modal {
		.el-dialog__header {
			display: none;
		}
	}

	/* Copy dropdown styles */
	.company-settings-dropdown__button.el-dropdown {
		.el-button--warning {
			background: #f9a168 !important;
		}
	}
}
</style>
